import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/hr/payroll/structures')({
  component: StructuresLayout,
})

function StructuresLayout() {
  return <Outlet />
}
